import { IcePopIcon } from './IcePopIcon';

/**
 * author: Nikos Pappas
 * id 58AA127F-3523-4B91-AFED-018FA36D0876
 * name ice-pop
 * version: 3.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ice-pop.svg
 * tags
 * - Food / Drink 
 */
export const PopsicleIcon = IcePopIcon;
export default PopsicleIcon